var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typeform",attrs:{"data-tf-widget":"SOvPUBsU","data-tf-iframe-props":"title=Demo request page","data-tf-medium":"snippet","data-tf-transitive-search-params":"utm_source,utm_campaign,utm_medium,utm_content"}})}
var staticRenderFns = []

export { render, staticRenderFns }